module.exports = __webpack_public_path__ + "b5bb48723728417971bc43e18bf0fea9.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/AU.svg
// module id = VY8Z
// module chunks = 0